// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')
// Sibling imports
const {
  HIDE,
  FRIENDS_FAILED,
  FRIENDS_LOADED,
  FRIENDS_LOADING,
  FRIENDS_SEARCH,
  FRIENDS_TOGGLE,
  SHOW,
  SUBMIT_LOADING,
  SUBMIT_LOADED,
  SUBMIT_FAILED
} = require('./actions')
const ShareModalRecord = require('./record')

// eslint-disable-next-line complexity
function shareModalReducer(state = new ShareModalRecord(), { type, payload }) {
  switch (type) {
    case SHOW:
      return (state || new ShareModalRecord).showModel(payload.model)
    case HIDE:
      return state.reset()
    case FRIENDS_LOADING:
      return state.merge({
        friendsState: FetchStateEnum.LOADING
      })
    case FRIENDS_LOADED:
      return state.merge({
        friendsState: FetchStateEnum.LOADED,
        friends: Immutable.fromJS(
          payload.friends,
          ShareModalRecord.friendsReviver
        )
      })
    case FRIENDS_FAILED:
      return state.merge({
        friendsState: FetchStateEnum.FAILED
      })
    case FRIENDS_SEARCH:
      return state.merge({
        searchText: payload.searchText
      })
    case FRIENDS_TOGGLE:
      return state.toggleFriend(payload.userId)
    case SUBMIT_LOADING:
      return state.merge({
        submitState: FetchStateEnum.LOADING
      })
    case SUBMIT_LOADED:
      return state.merge({
        submitState: FetchStateEnum.LOADED
      })
    case SUBMIT_FAILED:
      return state.merge({
        submitState: FetchStateEnum.FAILED
      })
    default:
      return state
  }
}

module.exports = shareModalReducer
